/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */

import type { Client, RequestContext } from "../client";
import type { ActionBulkUpdateResultResource, ActionsUpdateProcessResource, ActionTemplateCategoryResource, ActionTemplateResource, ActionTemplateUsageResource, ActionUpdateResource } from "../resources";
import type { ActionProperties } from "../resources/actionProperties";
import type { ActionTemplateSearchResource } from "../resources/actionTemplateSearchResource";
import type { CommunityActionTemplateResource } from "../resources/communityActionTemplateResource";
import type { ListArgs } from "./basicRepository";
import { BasicRepository } from "./basicRepository";

export type ActionTemplateListArgs = ListArgs & {
    partialName?: string;
    isCommunityActionTemplate?: boolean;
};

export class ActionTemplateRepository extends BasicRepository<ActionTemplateResource, ActionTemplateResource, ActionTemplateListArgs> {
    constructor(client: Client, requestContext: RequestContext) {
        super("ActionTemplates", client, requestContext);
    }
    getUsage(template: Partial<ActionTemplateResource>, args?: any): Promise<ActionTemplateUsageResource[]> {
        return this.client.get(this.requestContext, template.Links!["Usage"], args);
    }
    getByCommunityTemplate(communityTemplate: CommunityActionTemplateResource) {
        const allArgs = { ...{}, ...{ id: communityTemplate.Id } };
        return this.client.get<ActionTemplateResource>(this.requestContext, communityTemplate.Links["InstalledTemplate"], allArgs);
    }
    updateActions(actionTemplate: Partial<ActionTemplateResource>, actionsToUpdate: ActionsUpdateProcessResource[], defaults: ActionProperties = {}, overrides: ActionProperties = {}) {
        const resource: ActionUpdateResource = {
            ActionsToUpdate: actionsToUpdate,
            Overrides: overrides || {},
            DefaultPropertyValues: defaults || {},
            Version: actionTemplate.Version!,
        };
        return this.client.post(this.requestContext, actionTemplate.Links!["ActionsUpdate"], resource);
    }
    bulkUpdateActions(actionTemplate: Partial<ActionTemplateResource>, actionsToUpdate: ActionsUpdateProcessResource[], defaults: ActionProperties = {}, overrides: ActionProperties = {}) {
        const resource: ActionUpdateResource = {
            ActionsToUpdate: actionsToUpdate,
            Overrides: overrides || {},
            DefaultPropertyValues: defaults || {},
            Version: actionTemplate.Version!,
        };
        return this.client.post<ActionBulkUpdateResultResource>(this.requestContext, actionTemplate.Links!["ActionsBulkUpdate"], resource);
    }
    getVersion(actionTemplate: ActionTemplateResource, version: any): Promise<ActionTemplateResource> {
        return this.client.get(this.requestContext, actionTemplate.Links["Versions"], { version });
    }
    getAllVersions(actionTemplate: ActionTemplateResource): Promise<number[]> {
        return this.client.get(this.requestContext, "~/bff/spaces/{spaceId}/actiontemplates/{id}/versions", { id: actionTemplate.Id });
    }
    categories(): Promise<ActionTemplateCategoryResource[]> {
        return this.client.get<ActionTemplateCategoryResource[]>(this.requestContext, this.client.getLink("ActionTemplatesCategories"));
    }
}

export class ActionTemplateV2Repository {
    constructor(
        private readonly client: Client,
        private readonly requestContext: RequestContext
    ) {
        this.client = client;
    }

    search(args?: { type?: string }): Promise<ActionTemplateSearchResource[]> {
        return this.client.get<ActionTemplateSearchResource[]>(this.requestContext, "/api{/spaceId}/actiontemplates/search/v2{?type}", args);
    }

    searchSystem(args?: { type?: string; IncludeProcessTemplates?: boolean }): Promise<ActionTemplateSearchResource[]> {
        return this.client.get<ActionTemplateSearchResource[]>(this.requestContext, "/api/actiontemplates/search/v2{?type,IncludeProcessTemplates}", args);
    }
}
